(function () {
  // Guard: this file is loaded both globally (theme.liquid) and by widget
  // sections -- make sure listeners are only registered once.
  if (window.__nordrQuickViewInit) return;
  window.__nordrQuickViewInit = true;

  // Lazily create ONE shared quick-add modal we can reuse for single-variant
  // products. Dawn only renders a <quick-add-modal> for products with more than
  // one variant; single-variant cards render a plain add-to-cart <product-form>
  // instead. To still show a quick-view popup for them we host our own modal.
  function getForcedModal() {
    var existing = document.getElementById('QuickAdd-forced');
    if (existing) return existing;
    var wrap = document.createElement('div');
    wrap.innerHTML =
      '<quick-add-modal id="QuickAdd-forced" class="quick-add-modal">' +
      '  <div role="dialog" aria-modal="true" class="quick-add-modal__content global-settings-popup" tabindex="-1">' +
      '    <button id="ModalClose-forced" type="button" class="quick-add-modal__toggle" aria-label="Schließen">' +
      '      <svg class="icon icon-close" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">' +
      '        <line x1="5" y1="5" x2="19" y2="19"></line><line x1="19" y1="5" x2="5" y2="19"></line>' +
      '      </svg>' +
      '    </button>' +
      '    <div id="QuickAddInfo-forced" class="quick-add-modal__content-info"></div>' +
      '  </div>' +
      '</quick-add-modal>';
    var modal = wrap.firstElementChild;
    document.body.appendChild(modal);
    return modal;
  }

  // A single reusable, visually-hidden opener element. quick-add-modal.show()
  // reads its data-product-url and toggles a .loading__spinner child, so we give
  // it both. We reuse ONE element (updating data-product-url each time) instead
  // of ever mutating the card's real button -- otherwise the card button would
  // gain data-product-url and be treated as a native modal opener on the next
  // click, sending the item straight to the cart again.
  function getForcedOpener() {
    var existing = document.getElementById('nordr-forced-opener');
    if (existing) return existing;
    var opener = document.createElement('span');
    opener.id = 'nordr-forced-opener';
    opener.tabIndex = -1;
    opener.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;clip:rect(0 0 0 0);';
    var spinner = document.createElement('div');
    spinner.className = 'loading__spinner hidden';
    opener.appendChild(spinner);
    document.body.appendChild(opener);
    return opener;
  }

  // Intercepts clicks on product cards inside the "related products" /
  // "Trag dazu" widgets on the product page and opens a quick-add / quick-view
  // popup instead of navigating away or (for single-variant products) adding
  // straight to the cart.
  document.addEventListener('click', function (event) {
    var container = event.target.closest('.related-products, .complete-the-look');
    if (!container) return;

    var clickedTitleOrMedia = event.target.closest('.card__heading a, .card__media');
    if (!clickedTitleOrMedia) return;

    var card = event.target.closest('.card-wrapper');
    if (!card) return;

    // Multi-variant / has-options products: Dawn renders a real modal opener
    // button carrying data-product-url. Click it to open the native modal.
    var nativeOpener = card.querySelector('.quick-add__submit[data-product-url]');
    if (nativeOpener) {
      event.preventDefault();
      nativeOpener.click();
      return;
    }

    // From here the card has no native modal. If it has no quick-add button at
    // all (quick add disabled for this widget), let the card navigate normally.
    var addToCartBtn = card.querySelector('.quick-add__submit');
    if (!addToCartBtn) return;

    // Single-variant product: DO NOT click the add-to-cart button (that is what
    // dropped the item straight into the cart). Instead force our shared
    // quick-view popup, loading the product page like the native modal does.
    var link = card.querySelector('a[href]');
    var url = link && link.getAttribute('href');
    if (!url) return;

    event.preventDefault();
    var opener = getForcedOpener();
    opener.setAttribute('data-product-url', url);
    getForcedModal().show(opener);
  });

  // Once the quick-add modal content has been injected, move the
  // "view full details" link out of the info column, restyle it as a
  // button and place it below the media gallery (bottom of the image
  // column -- styling lives in nordr-custom.css).
  function enhanceQuickAddModal(modal) {
    var link = modal.querySelector('.product__view-details');
    var mediaWrapper = modal.querySelector('.product__media-wrapper');
    if (!link || !mediaWrapper || mediaWrapper.contains(link)) return;
    link.classList.remove('link', 'animate-arrow');
    link.classList.add('button', 'product__view-details--button');
    mediaWrapper.appendChild(link);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1 || !node.closest) continue;
        var modal = node.closest('quick-add-modal');
        if (modal) enhanceQuickAddModal(modal);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Fix for a Dawn bug in the quick-add modal: the modal prefixes all
  // section ids with "quickadd-" (preventDuplicatedIDs), but on variant
  // change product-info.js diffs the gallery against freshly fetched HTML
  // whose data-media-id values are UNprefixed. The diff then treats every
  // existing media item as stale and the gallery loses images on each
  // variant click. Normalizing the fetched ids to the prefixed form before
  // the diff makes the modal behave exactly like the product page.
  customElements.whenDefined('product-info').then(function () {
    var ProductInfoClass = customElements.get('product-info');
    if (!ProductInfoClass || ProductInfoClass.__nordrMediaIdPatch) return;
    ProductInfoClass.__nordrMediaIdPatch = true;

    var originalUpdateMedia = ProductInfoClass.prototype.updateMedia;
    ProductInfoClass.prototype.updateMedia = function (html, variantFeaturedMediaId) {
      var originalSection = this.dataset.originalSection;
      var currentSection = this.dataset.section;
      if (html && originalSection && currentSection && originalSection !== currentSection) {
        html.querySelectorAll('media-gallery [data-media-id]').forEach(function (item) {
          item.dataset.mediaId = item.dataset.mediaId.split(originalSection).join(currentSection);
        });
      }
      return originalUpdateMedia.call(this, html, variantFeaturedMediaId);
    };
  });
})();
